export type ResponseAuditDataFieldsBody = {
  paramDefinitionId: string;
  value: string;
};
